import { DateTime } from 'luxon';

import { isServiceOrder, type OrderSummary } from '#domain/Order.ts';

export type OrderPeriod = 'all' | 'today' | '24' | '48' | '72' | 'custom';
export type OrderTimeRange = { start: number; end: number };

export const customOrderRange = (from?: Date, to?: Date): OrderTimeRange | undefined => {
    if (!from || !to) {
        return undefined;
    }
    const start = DateTime.fromJSDate(from).startOf('day');
    const lastDay = DateTime.fromJSDate(to).startOf('day');
    if (!start.isValid || !lastDay.isValid || lastDay < start) {
        return undefined;
    }
    return { start: start.toMillis(), end: lastDay.plus({ days: 1 }).toMillis() };
};

export const resolveOrderPeriod = (period: Exclude<OrderPeriod, 'custom'>, now: number): OrderTimeRange | undefined => {
    if (period === 'all') {
        return undefined;
    }
    if (period === 'today') {
        const start = DateTime.fromMillis(now).startOf('day');
        return { start: start.toMillis(), end: start.plus({ days: 1 }).toMillis() };
    }
    return { start: now, end: now + Number(period) * 60 * 60 * 1000 };
};

export const matchesOrderTimeRange = (order: OrderSummary, range?: OrderTimeRange) => {
    if (!range) {
        return true;
    }
    const stop = isServiceOrder(order) ? order.executionStop : order.loadingStop;
    const start = DateTime.fromISO(stop.startTarget).toMillis();
    const end = DateTime.fromISO(stop.endTarget).toMillis();
    return Number.isFinite(start) && Number.isFinite(end) && end >= start && start < range.end && end >= range.start;
};
